__turbopack_context__.v({
  "Cta": "Doormat-module-scss-module__kUn6LG__Cta",
  "Doormat": "Doormat-module-scss-module__kUn6LG__Doormat",
  "Image": "Doormat-module-scss-module__kUn6LG__Image",
  "Inner": "Doormat-module-scss-module__kUn6LG__Inner",
});
